import { ColumnDef } from '@tanstack/react-table';
import i18n from 'i18next';

import { TableData } from '@/types';

export const getVideoThemeTextColumns: () => ColumnDef<TableData>[] = () => {
  const alignmentMapping = ['Left', 'Center', 'Right'];
  const SCREEN_LG_BREAKPOINT = 1024;
  const defaultVideoThemeTextColumns: ColumnDef<TableData>[] = [
    {
      id: 'value',
      accessorKey: 'value',
      header: i18n.t('textValue', { ns: 'common' }),
      cell: ({ getValue }) => {
        const value = getValue() as string;
        return (
          <div className='truncate md:max-w-[180px] lg:max-w-[240px]' title={value}>
            {value}
          </div>
        );
      }
    },
    {
      id: 'fontFamily',
      accessorKey: 'fontFamily',
      header: i18n.t('font', { ns: 'common' }),
      cell: ({ getValue }) => {
        const value = getValue() as string;
        return (
          <div className='truncate md:max-w-[150px] lg:max-w-[200px]' title={value}>
            {value}
          </div>
        );
      }
    },
    {
      id: 'fontSize',
      accessorKey: 'fontSize',
      header: i18n.t('size', { ns: 'common' })
    },
    {
      id: 'textColor',
      accessorKey: 'textColor',
      header: i18n.t('color', { ns: 'common' }),
      cell: ({ getValue }) => {
        const color = getValue() as string;
        return (
          <div className='flex items-center gap-2'>
            <span
              className='size-5 rounded-full border border-gray-300 md:justify-start'
              style={{ backgroundColor: color }}
              title={color}
            />
          </div>
        );
      }
    },
    {
      id: 'alignment',
      accessorKey: 'alignment',
      header: i18n.t('alignment', { ns: 'common' }),
      cell: ({ getValue }) => {
        const alignmentIndex = getValue() as number;
        return alignmentMapping[alignmentIndex] || 'Unknown';
      }
    },
    ...(window.innerWidth >= SCREEN_LG_BREAKPOINT
      ? [
          {
            id: 'startTime',
            accessorKey: 'startTime',
            header: i18n.t('start', { ns: 'common' }),
            cell: ({ getValue }: { getValue: () => unknown }) => {
              const seconds = Number(getValue());
              const minutes = Math.floor(seconds / 60);
              const remainingSeconds = seconds % 60;
              return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
                .toString()
                .padStart(2, '0')}`;
            }
          },
          {
            id: 'endTime',
            accessorKey: 'endTime',
            header: i18n.t('end', { ns: 'common' }),
            cell: ({ getValue }: { getValue: () => unknown }) => {
              const seconds = Number(getValue());
              const minutes = Math.floor(seconds / 60);
              const remainingSeconds = seconds % 60;
              return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
                .toString()
                .padStart(2, '0')}`;
            }
          }
        ]
      : [])
  ];

  return defaultVideoThemeTextColumns;
};
